import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import HomePage from '../Login/HomePage';
import LoginForm from '../Login/LoginForm';

const LoginLayout = () => {
  return (
    // <HomePage />
    <LoginForm />
  )
}
export default LoginLayout;
